import { DisplayValueType } from '../display-value-type';
import { AppointmentRole } from '../../../enums/appointment-role.enum';

export class AppointmentType extends DisplayValueType {
  appointmentTypeId: string;
  duration: number;
  insurancePrompt: boolean;
  role: AppointmentRole;
}
